import { createReducer, on } from '@ngrx/store';
import * as UserActions from './users.actions';
import { UserState } from './users.model';

export const initialState: UserState = {
  users: [],
  loading: false,
  error: null,
  loaded: false
};

export const usersReducer = createReducer(
  initialState,
  on(UserActions.loadUsers, state => ({ ...state, loading: true })),
  on(UserActions.loadUsersSuccess, (state, { users }) => ({ ...state, users, loading: false, loaded: true })),
  on(UserActions.loadUsersFailure, (state, { error }) => ({ ...state, error, loading: false, loaded: false }))
);